'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dataStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _check = require('../lib/check');

var _DataStoreNamespace = require('./DataStoreNamespace');

var _DataStoreNamespace2 = _interopRequireDefault(_DataStoreNamespace);

var _Api = require('../api/Api');

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class DataStore
 *
 * @description
 * Represents the dataStore that can be interacted with. This can be used to get instances of DataStoreNamespace, which
 * can be used to interact with the namespace API.
 *
 * Example usage:
 * ```js
 * import init from 'd2';
 * init({baseUrl: '/dhis/api'})
 *   .then((d2) => {
 *     d2.dataStore.get('namespace').then(namespace => {
 *          namespace.get('key').then(value => console.log(value))
 *      });
 *   });
 * ```
 */

var DataStore = function () {
    function DataStore() {
        var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _Api2.default.getApi();

        _classCallCheck(this, DataStore);

        this.endPoint = 'dataStore';

        this.api = api;
    }

    /**
     * Retrieves a list of keys for the given namespace, and returns an instance of DataStoreNamespace that
     * may be used to interact with this namespace. See {@link DataStoreNamespace}.
     *
     *Note that to create a new namespace, a key and a value needs to exists.
     * Example for creation of a new namespace
     * '''js
     * d2.dataStore.get('new namespace').then(namespace => {
     *     namespace.set('new key', value);
     *'''
     * @param namespace to get.
     * @param autoLoad if true, autoloads the keys of the namespace before the namespace is created. If false, an instance of
     * the namespace is returned without any keys. Default true
     * @returns {Promise<DataStoreNamespace>} An instance of a DataStoreNamespace representing the namespace that can be interacted with.
     */


    _createClass(DataStore, [{
        key: 'get',
        value: function get(namespace) {
            var autoLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (!autoLoad) {
                return new Promise(function (resolve) {
                    resolve(new _DataStoreNamespace2.default(namespace));
                });
            }

            return this.api.get([this.endPoint, namespace].join('/')).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    return new _DataStoreNamespace2.default(namespace, response);
                }
                throw new Error('The requested namespace has no keys or does not exist.');
            }).catch(function (e) {
                if (e.httpStatusCode === 404) {
                    // If namespace does not exist, provide an instance of DataStoreNamespace
                    // so it's possible to interact with the namespace.
                    return new _DataStoreNamespace2.default(namespace);
                }
                throw e;
            });
        }

        /**
         * Retrieves a list of all public namespaces on the server.
         * @returns {Promise} with an array of namespaces.
         */

    }, {
        key: 'getAll',
        value: function getAll() {
            return this.api.get(this.endPoint).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    return response;
                }
                throw new Error('No namespaces exist.');
            });
        }

        /**
         * Deletes a namespace
         * @param namespace to delete
         * @returns {Promise} with the response from the API.
         */

    }, {
        key: 'delete',
        value: function _delete(namespace) {
            return this.api.delete([this.endPoint, namespace].join('/'));
        }
    }]);

    return DataStore;
}();

var dataStore = exports.dataStore = function () {
    return new DataStore();
}();

exports.default = DataStore;
//# sourceMappingURL=DataStore.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/datastore/DataStore.js
// module id = 481
// module chunks = 0